import React from 'react';
import { PageTitle } from '../../../_metronic/layout/core';
import { BudgetManager } from './QuoteManager';

const BudgetPage: React.FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={[]}>Construction Cost Calculator</PageTitle>
      <BudgetManager />
    </>
  );
};

export { BudgetPage } 